<template>
	<v-container fluid>

		<v-row>
	  	<v-col cols="12" class="pa-0">
	  		<v-toolbar dense class="elevation-0" color="primary" dark>
		      <v-toolbar-title>Curso Exci</v-toolbar-title>
		      <v-spacer></v-spacer>
		    </v-toolbar>
	  	</v-col>
	  </v-row>

	  <v-row>
	  	<v-col cols="12" md="8" class="pt-0 pl-0 pr-0">
	  		<v-card-actions class="px-0 pt-0 pl-0 pr-0">
      		<video
      			v-if="tipoMaterial == 'mp4'" 
      			id="video" 
      			:src="`${url}`" 
	    			frameborder="0" 
	    			allowfullscreen
	    			controls
	    			allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
	         	style="width: 100%; height: 100%; background: #FFFFFF;" allowtransparency="true">
	        </video>

          <embed 
          	v-if="tipoMaterial == 'pdf' && visiblePdf" 
          	:src="`${pathViewerPdf}/web/viewer.html?file=`+url" width="100%" 
          	:height="tamanioPantalla"
          >

      	</v-card-actions>
	  	</v-col>

	  	<v-col cols="12" md="4" class="pt-2 pl-0 pr-0">
	  		<!-- Información básica del grupo -->
	  		<v-card class="">
	  			<v-card-text>
						<div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
              Contenido del curso
            </div>
	  			</v-card-text>
	  			<v-list>
			      <v-list-group
			        v-for="(material, i) in materialClase"
			        :key="i"
		          v-model="material.active"
		          no-action
		          dense
			      >
			        <template v-slot:activator>
			        	<v-list-item-icon>
		              <v-icon v-text="material.action" color="primary"></v-icon>
		            </v-list-item-icon>
			          <v-list-item-title>{{ material.titulo }}</v-list-item-title>
			        </template>

		          <v-list-item
		            v-for="( desglose, j) in material.materiales"
		            :key="j"
		            link
		            dense
		            @click="verMaterial( desglose )"
		          >
		            <v-list-item-icon>
		              <v-icon v-text="desglose.icon" :color="desglose.tipo == 'pdf' ? 'red' : 'primary'"></v-icon>
		            </v-list-item-icon>
		            <v-list-item-title v-text="desglose.nombre"></v-list-item-title>

		          </v-list-item>
			      </v-list-group>
			    </v-list>
	  		</v-card>					
	  	</v-col>
	  </v-row>
	</v-container>
</template>

<script>
	// importar librerías
	import { mapGetters, mapActions } from 'vuex'

	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

  const  base64 = require('base-64');

	export default {
	  name: "dashboard-default",
	  data: () => ({
	  	url: '',

	    loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},
     	respuestaAlerta: false,
     	visiblePdf: true,

     	material: null,
     	tipoMaterial:'pdf',

     	pathDirecta: 'https://lms.fastenglish.com.mx/recursos/EXCI/curso',
     	pathViewerPdf: 'https://lms.fastenglish.com.mx/recursos/EXCI/viewer',

     	materialClase:[],

     	accesoExci: null,
     	filtermaterialClase: []
	  }),

	  components: {
	    Alerta,
	    Loader
	  },

	  computed:{
	  	...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getRecurso' ]),

	  	tamanioPantalla () {
	      switch (this.$vuetify.breakpoint.name) {
	        case 'xs':
	          return (this.$vuetify.breakpoint.height / 2)
	        break;
	        case 'sm': 
	          return this.$vuetify.breakpoint.height - 185
	        break;
	        case 'md':
	          return this.$vuetify.breakpoint.height - 185
	        break;
	        case 'lg':
	          return this.$vuetify.breakpoint.height - 185
	        break;
	        case 'xl':
	          return this.$vuetify.breakpoint.height - 185
	        break;
	      }
    	},
	  },

	  created(){
	  	this.url = this.pathDirecta + '/1/Bienvenida.pdf'
	  	this.getCursoExci( )
	  },

	  methods:{
	  	...mapActions( 'login', [ 'abrirRecursosAlumno', 'abrirVentanaRecurso','guardar_id_evaluacion_exci', 'guardar_id_evaluacion_exci_ejercicio'] ),
	  	descargarPdf( ruta ){
	  		window.open(`${this.url}${ruta}`)
	  	},

	  	getCursoExci( ){
        const id_usuario = base64.encode( this.getUsuarioLMS.iderp )
        // Hacemos la petición
        this.$http.get('exci.activar.usuario/' + id_usuario).then( response => {
          this.materialClase = response.body
        }).catch( error =>{
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      },

	  	verRecursos ( ){
	  		this.cargar = true
	  		const payload = {
					id_usuario: this.getUsuarioLMS.id, 
					id_curso:   this.getGrupo.grupo.id_curso,
					id_nivel:   this.getGrupo.grupo.id_nivel,
					id_grupo:   this.getGrupo.grupo.id,
					lecciones:  this.getGrupo.info_curso.dias_clase,
					tipo:       this.getGrupo.grupo.tipo
	  		}

	  		this.abrirRecursosAlumno( payload ).then(response => { 
	  			this.cargar = false
	  		}).catch( error =>{
    			this.validarErrores ( error )
    		}).finally( () => { this.cargar = false })
	  	},

	  	validarErrores ( value ){
	  		this.cargar = false
  			if( value.status == 400 || value.status == 500 ){
    			this.parametros.mensaje = value.body.message
  				this.parametros.color        = '#FF2C2C'
    			this.parametros.dialogError  = true 
    			this.respuestaAlerta = true 
    		}
	  	},

	  	verMaterial( material ){

	  		if( material.tipo == 'examen'){
	  			this.guardar_id_evaluacion_exci( material.id )
	  		}else if( material.tipo == 'ejercicio'){
	  			this.guardar_id_evaluacion_exci_ejercicio( material.id )
	  		}else{
	  			this.visiblePdf = false

		  		this.material = material
		  		this.url = this.pathDirecta + material.path
		  		this.tipoMaterial = material.tipo
		  		setTimeout(() => {this.visiblePdf = true}, 1000);
	  		}
	  	}
	  }
	};
</script>

<style scoped>
	.avatares{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
	}
	
	.colorCurso{
		color: #006093;
	}

	.v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item {
    padding-left: 35px;
	}

	#viewerContainer::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  #viewerContainer > #viewerContainer::-webkit-scrollbar:vertical {
    width: 10px !important;
  }

  #viewerContainer::-webkit-scrollbar:vertical{
    width: 10px !important;
  }

  #viewerContainer::-webkit-scrollbar-button:increment,#viewerContainer::-webkit-scrollbar-button{
    display: none;
  }

  #viewerContainer::-webkit-scrollbar:horizontal{
    height: 10px !important;
  }

  #viewerContainer::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }


</style>
